import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import "./styles.css";

// MUI
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";

const getSectionLabel = (identifier = "") => {
	const sections = {
		bodyShop: "Body Shop",
		parts: "Parts",
		service: "Service",
	};
	return sections?.[identifier] || "Unknown";
};

export default function GrossBonusOptions(props) {
	const {
		defaultIdentifier = "bodyShop",
		options = {
			bodyShop: false,
			parts: false,
			service: false,
		},
		disabledDistance = 1,
		disabled = false,
		readOnly = false,
		onChangeOptions = () => {},
	} = props;

	const [innerOptions, setInnerOptions] = useState({
		bodyShop: false,
		parts: false,
		service: false,
	});

	const handleChange = (section, value) => {
		const updatedOptions = { ...innerOptions, [section]: value };
		setInnerOptions(updatedOptions);
		onChangeOptions?.(updatedOptions);
	};

	const isDisabledControl = useMemo(() => {
		if (!innerOptions) {
			return false;
		}

		const totalOptions = Object.entries(innerOptions).length;
		const uncheckedOptions = Object.entries(innerOptions).reduce((acc, definition) => {
			const [, value] = definition;
			acc += !value ? 1 : 0;
			return acc;
		}, 0);

		return uncheckedOptions >= totalOptions - disabledDistance;
	}, [innerOptions, disabledDistance]);

	useEffect(() => {
		setInnerOptions(
			options || {
				bodyShop: Boolean(defaultIdentifier === "bodyShop"),
				parts: Boolean(defaultIdentifier === "parts"),
				service: Boolean(defaultIdentifier === "service"),
			}
		);

		return () => {
			setInnerOptions({
				bodyShop: false,
				parts: false,
				service: false,
			});
		};
	}, [defaultIdentifier, options]);

	const disabledOptions = disabled || readOnly;

	return (
		<Stack width={1}>
			<Stack direction="row" spacing={2}>
				{Object.keys(innerOptions)?.map((option, key) => {
					const disabledSection = isDisabledControl && innerOptions?.[option];
					const disabledOption = disabledOptions || disabledSection;
					const title = getSectionLabel(option);

					return (
						<Stack key={`${title}_${key}`}>
							<FormControlLabel
								control={
									<Checkbox
										disabled={disabledOption}
										checked={!!innerOptions?.[option]}
										onChange={(_e, value) => handleChange(option, value)}
									/>
								}
								label={
									<Typography className="select-all-checkbox-text" fontSize={"17px !important"}>
										{title}
									</Typography>
								}
								labelPlacement="end"
							/>
						</Stack>
					);
				})}
			</Stack>
		</Stack>
	);
}
GrossBonusOptions.propTypes = {
	defaultIdentifier: PropTypes.string,
	options: PropTypes.shape({
		bodyShop: PropTypes.bool,
		parts: PropTypes.bool,
		service: PropTypes.bool,
	}),
	disabledDistance: PropTypes.number,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onChangeOptions: PropTypes.func,
};
